import React, { useState } from 'react';

import Button from '~components/Button';
import { faCopy } from '~components/icon';
import Icon from '~components/icon/Icon';
import Modal from '~components/Modal';
import { Form as WizardForm } from '~components/wizard-form';

import bulkCopyFields from '~support-at-home/forms/budgets/bulkCopy';

import { BulkCopyLockContext } from './BulkCopyLockContext';

interface ComponentProps {
  canUpdate: boolean;
}

const BudgetBulkCopy: React.FC<ComponentProps> = ({ canUpdate }) => {
  const [isOpen, setIsOpen] = useState(false);
  // Locked while a copy is running (set by the Review step via BulkCopyLockContext) — the modal
  // must not be closeable mid-copy, as that would abandon the not-yet-copied budgets (TAV-2968).
  const [isCopying, setIsCopying] = useState(false);

  // Block every close path (header close button, backdrop click, ESC) while copying.
  const handleSetIsOpen = (open: boolean) => {
    if (isCopying && !open) return;
    setIsOpen(open);
  };

  if (!canUpdate) return null;
  return (
    <div className="d-flex align-items-center me-2">
      <Button id="budgets-bulk-copy-button" size="sm" onClick={() => setIsOpen(true)}>
        <Icon className="me-2" icon={faCopy} />
        Bulk Copy
      </Button>
      <Modal
        size="xl"
        isOpen={isOpen}
        setIsOpen={handleSetIsOpen}
        onClose={() => handleSetIsOpen(false)}
        headerClassName="header"
        header="Budget Bulk Copy"
        className="budgets-bulk-copy-wizard-modal"
        includeFooter={false}
        backdrop={isCopying ? 'static' : true}
        keyboard={!isCopying}
        disableClose={isCopying}
        unmountOnClose
      >
        <BulkCopyLockContext.Provider value={setIsCopying}>
          <WizardForm steps={bulkCopyFields} onComplete={() => handleSetIsOpen(false)} submitCaption="Close" />
        </BulkCopyLockContext.Provider>
      </Modal>
    </div>
  );
};

export default BudgetBulkCopy;
